<script>
export default {
    props: ["vnode"],
    render(h) {
        return this.vnode;
    },
};
</script>
